import { useLocation } from 'wouter';
import { AppContainer } from './AppContainer';

export function AppLayout({ children }) {
    return <AppContainer>{children}</AppContainer>;
}
